export default __webpack_public_path__ + "static/media/hadith_learning.8483cab1.png";